import { createChangeRouteAction } from "../../../state/router/createChangeRouteAction";
import { makeJobLinkOutOfRouteAction } from "../../CRMJobs/CRMJobsOverlay/CRMJobsCardLinkGenerators";
import { TBlocksParamsObject, TRouteActionTypeWithBlocks } from "../../../state/router/routerTypes";
import { TCaseTabs } from "../../../pages/CRMLegalCasePage/CRMLegalCasePage";

type BlocksArray = TBlocksParamsObject<TRouteActionTypeWithBlocks>;

export type TWaitingOnSubject =
    | { kind: "roadblock"; roadblock_id: string }
    | { kind: "enquiries" }
    | { kind: "documents" }
    | { kind: "ad_hoc_jobs" }
    | { kind: "inbox_emails" }
    | { kind: "complaint" }
;

const caseLink = (caseId: string, visibleTab: TCaseTabs, openRoadblockID?: string): string => {
    const blocks: BlocksArray = [
        { type: "case_details", meta: {} },
        { type: "case_overview", meta: {} },
        { type: "case_roadblocks", meta: openRoadblockID ? { openRoadblockID } : {} },
    ];
    return makeJobLinkOutOfRouteAction(
        createChangeRouteAction(
            "VIEW_CRM_LEGAL_CASE",
            { caseId },
            { visible_tab: visibleTab },
            blocks,
        ),
    );
};

export const getWaitingOnSubjectLink = (
    caseId: string,
    subject: TWaitingOnSubject | undefined,
): string | null => {
    if (subject === undefined) {
        return null;
    }
    switch (subject.kind) {
        case "roadblock":
            return caseLink(caseId, "details", subject.roadblock_id);
        case "ad_hoc_jobs":
            return caseLink(caseId, "details");
        case "enquiries":
            return caseLink(caseId, "enquiries");
        case "documents":
            return caseLink(caseId, "document_management");
        case "inbox_emails":
            return caseLink(caseId, "emails");
        case "complaint":
            return caseLink(caseId, "satisfaction");
    }
};
